import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

window.disableBodyScroll = disableBodyScroll;
window.enableBodyScroll = enableBodyScroll;